<script lang="ts">
    import {Utils} from "../util";
    import type {Community} from "../models/model";
    import { _ } from '../services/i18n';
    export let communityData: Community | null = null;
    export let hideUI = false;

    let websiteUrl = null;

    let address = "";
    //not working sometimes because not updating the location-->    $: address = `${l.houseNumber}, ${l.street} L-${l.postalCode} ${Utils.chooseTranslation(communityData?.name)}`;

    //because of bad import, we can have string or translated json at the same time...
    $: if(typeof communityData?.website === 'string'){
        websiteUrl = communityData?.website;
    }else{
        websiteUrl = Utils.chooseTranslation(communityData?.website);
    }

    $: website = websiteUrl.replace(/^https?:\/\//, ''); //remove http or https from string;

    $: {
        let l = communityData?.location;

        if(!l.street){
            l.street = '';
        }

        if(!l.postalCode){
            l.postalCode = '';
        }

        if(l?.houseNumber){
            address = `${l.houseNumber}, ${l?.street} L-${l?.postalCode} ${l?.city}`; //${Utils.chooseTranslation(communityData?.name)}

        }else{
            address = `${l?.street} L-${l.postalCode} ${l?.city}`; //${Utils.chooseTranslation(communityData?.name)}

        }
    }

</script>


<div class="location-wrapper">
    <div class="location-item">
        <label>{$_('location.address')}</label>
        <span>{address}</span>
    </div>
    <div class="location-item" style="display: {communityData?.phone == null ? 'none' : ''}">
        <label>{$_('location.phone')}</label>
        <span>{communityData?.phone}</span>
    </div>
    <div class="location-item" style="display: {websiteUrl == null ? 'none' : ''}">
        <label>{$_('location.website')}</label>
        <span>
            <a id="websiteButton"
               href={Utils.urlify(websiteUrl)} target="_blank">{website}
            </a>
        </span>
    </div>
</div>

<style lang="scss">

  .location-wrapper {

    display: flex;
    flex-direction: column;
    //row-gap:20px;


    .location-item {

      display: flex;
      justify-content: space-between;
      border-bottom: 2px dashed #F8F7F7;
      column-gap: 20px;
      align-items: center;
      padding-top: 10px;
      padding-bottom: 10px;

      label {
        //background: red;

      }

      span {
        align-items: center;
        display: flex;
        //background: yellow;
      }

      a {

        color: inherit;

      }

    }

  }


</style>
